import { render, staticRenderFns } from "./productsreal.vue?vue&type=template&id=3d30ad59&"
import script from "./productsreal.vue?vue&type=script&lang=js&"
export * from "./productsreal.vue?vue&type=script&lang=js&"
import style0 from "./productsreal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports